import { __spreadArray } from "tslib";
import extractSymbol from './extract-symbol';
import loadSvgCached from './load-svg-cached';
import loadSvgUncached from './load-svg-uncached';
import parseDataUrl from './parse-data-url';
import uniqueId from './unique-id';
var injectedElements = [];
var ranScripts = {};
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';
var injectElement = function (el, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, callback) {
    var _a;
    var elUrl = (_a = el.getAttribute('data-src')) !== null && _a !== void 0 ? _a : el.getAttribute('src');
    if (!elUrl) {
        callback(new Error('Invalid data-src or src attribute'));
        return;
    }
    if (injectedElements.indexOf(el) !== -1) {
        injectedElements.splice(injectedElements.indexOf(el), 1);
        el = null;
        return;
    }
    injectedElements.push(el);
    el.setAttribute('src', '');
    var hashIndex = elUrl.indexOf('#');
    var baseUrl = hashIndex !== -1 ? elUrl.slice(0, hashIndex) : elUrl;
    var symbolId = hashIndex !== -1 ? elUrl.slice(hashIndex + 1) : null;
    var dataUrlResult = parseDataUrl(baseUrl);
    if (dataUrlResult instanceof Error) {
        injectedElements.splice(injectedElements.indexOf(el), 1);
        el = null;
        callback(dataUrlResult);
        return;
    }
    var handleLoadedSvg = function (error, loadedSvg) {
        var _a, _b;
        if (!loadedSvg) {
            injectedElements.splice(injectedElements.indexOf(el), 1);
            el = null;
            callback(error);
            return;
        }
        var svg = loadedSvg;
        if (symbolId) {
            var symbolSvg = extractSymbol(loadedSvg, symbolId);
            if (!symbolSvg) {
                injectedElements.splice(injectedElements.indexOf(el), 1);
                el = null;
                callback(new Error("Symbol \"".concat(symbolId, "\" not found in ").concat(baseUrl)));
                return;
            }
            svg = symbolSvg;
        }
        var elId = el.getAttribute('id');
        if (elId) {
            svg.setAttribute('id', elId);
        }
        var elTitle = el.getAttribute('title');
        if (elTitle) {
            svg.setAttribute('title', elTitle);
        }
        var elWidth = el.getAttribute('width');
        if (elWidth) {
            svg.setAttribute('width', elWidth);
        }
        var elHeight = el.getAttribute('height');
        if (elHeight) {
            svg.setAttribute('height', elHeight);
        }
        var mergedClasses = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], ((_a = svg.getAttribute('class')) !== null && _a !== void 0 ? _a : '').split(' '), true), [
            'injected-svg'
        ], false), ((_b = el.getAttribute('class')) !== null && _b !== void 0 ? _b : '').split(' '), true)))
            .join(' ')
            .trim();
        svg.setAttribute('class', mergedClasses);
        var elStyle = el.getAttribute('style');
        if (elStyle) {
            svg.setAttribute('style', elStyle);
        }
        svg.setAttribute('data-src', elUrl);
        var elData = [].filter.call(el.attributes, function (at) {
            return /^data-\w[\w-]*$/.test(at.name);
        });
        Array.prototype.forEach.call(elData, function (dataAttr) {
            if (dataAttr.name && dataAttr.value) {
                svg.setAttribute(dataAttr.name, dataAttr.value);
            }
        });
        if (renumerateIRIElements) {
            var iriElementsAndProperties_1 = {
                clipPath: ['clip-path'],
                'color-profile': ['color-profile'],
                cursor: ['cursor'],
                filter: ['filter'],
                linearGradient: ['fill', 'stroke'],
                marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
                mask: ['mask'],
                path: [],
                pattern: ['fill', 'stroke'],
                radialGradient: ['fill', 'stroke'],
            };
            var replaceIriReferences_1 = function (value, iriIdMap) {
                return value.replace(/url\((['"]?)\s*#([^\s'"\)]+)\s*\1\)/g, function (match, _quote, iriId) {
                    var newId = iriIdMap[iriId];
                    return newId ? "url(#".concat(newId, ")") : match;
                });
            };
            var replaceHrefReference = function (value, iriIdMap) {
                if (!value.startsWith('#')) {
                    return value;
                }
                var iriId = value.slice(1);
                var newId = iriIdMap[iriId];
                return newId ? '#' + newId : value;
            };
            var element_1;
            var elements_1;
            var properties_1;
            var currentId_1;
            var newId_1;
            var renumeratedElements_1 = [];
            var iriIdMap_1 = {};
            Object.keys(iriElementsAndProperties_1).forEach(function (key) {
                element_1 = key;
                elements_1 = svg.querySelectorAll(element_1 + '[id]');
                for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
                    var currentElement = elements_1[a];
                    currentId_1 = currentElement.id;
                    newId_1 = currentId_1 + '-' + uniqueId();
                    iriIdMap_1[currentId_1] = newId_1;
                    renumeratedElements_1.push({
                        element: currentElement,
                        currentId: currentId_1,
                        newId: newId_1,
                    });
                }
            });
            Object.keys(iriElementsAndProperties_1).forEach(function (key) {
                properties_1 = iriElementsAndProperties_1[key];
                var referencingElements;
                Array.prototype.forEach.call(properties_1, function (property) {
                    referencingElements = svg.querySelectorAll('[' + property + ']');
                    for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
                        var referencingElement = referencingElements[b];
                        var attrValue = referencingElement.getAttribute(property);
                        if (attrValue) {
                            var nextValue = replaceIriReferences_1(attrValue, iriIdMap_1);
                            if (nextValue !== attrValue) {
                                referencingElement.setAttribute(property, nextValue);
                            }
                        }
                    }
                });
            });
            var allLinks = svg.querySelectorAll('*');
            for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
                var link = allLinks[c];
                var href = link.getAttribute('href');
                if (href) {
                    var nextHref = replaceHrefReference(href, iriIdMap_1);
                    if (nextHref !== href) {
                        link.setAttribute('href', nextHref);
                    }
                }
                var xlinkHref = link.getAttributeNS(xlinkNamespace, 'href');
                if (xlinkHref) {
                    var nextXlinkHref = replaceHrefReference(xlinkHref, iriIdMap_1);
                    if (nextXlinkHref !== xlinkHref) {
                        link.setAttributeNS(xlinkNamespace, 'href', nextXlinkHref);
                    }
                }
            }
            var styleElements = svg.querySelectorAll('[style]');
            for (var d = 0, styleElementsLen = styleElements.length; d < styleElementsLen; d++) {
                var styleElement = styleElements[d];
                var styleValue = styleElement.getAttribute('style');
                if (styleValue) {
                    var nextStyleValue = replaceIriReferences_1(styleValue, iriIdMap_1);
                    if (nextStyleValue !== styleValue) {
                        styleElement.setAttribute('style', nextStyleValue);
                    }
                }
            }
            var styleTagElements = svg.querySelectorAll('style');
            for (var e = 0, styleTagElementsLen = styleTagElements.length; e < styleTagElementsLen; e++) {
                var styleTagElement = styleTagElements[e];
                var textContent = styleTagElement.textContent;
                if (textContent) {
                    var nextTextContent = replaceIriReferences_1(textContent, iriIdMap_1);
                    if (nextTextContent !== textContent) {
                        styleTagElement.textContent = nextTextContent;
                    }
                }
            }
            for (var f = 0, renumeratedElementsLen = renumeratedElements_1.length; f < renumeratedElementsLen; f++) {
                renumeratedElements_1[f].element.id = renumeratedElements_1[f].newId;
            }
        }
        svg.removeAttribute('xmlns:a');
        var scripts = svg.querySelectorAll('script');
        var scriptsToEval = [];
        var script;
        var scriptType;
        for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
            var scriptElement = scripts[i];
            scriptType = scriptElement.getAttribute('type');
            if (!scriptType ||
                scriptType === 'application/ecmascript' ||
                scriptType === 'application/javascript' ||
                scriptType === 'text/javascript') {
                script = scriptElement.innerText || scriptElement.textContent;
                if (script) {
                    scriptsToEval.push(script);
                }
                svg.removeChild(scriptElement);
            }
        }
        if (scriptsToEval.length > 0 &&
            (evalScripts === 'always' ||
                (evalScripts === 'once' && !ranScripts[elUrl]))) {
            for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
                new Function(scriptsToEval[l])(window);
            }
            ranScripts[elUrl] = true;
        }
        var styleTags = svg.querySelectorAll('style');
        Array.prototype.forEach.call(styleTags, function (styleTag) {
            styleTag.textContent += '';
        });
        svg.setAttribute('xmlns', svgNamespace);
        svg.setAttribute('xmlns:xlink', xlinkNamespace);
        beforeEach(svg);
        if (!el.parentNode) {
            injectedElements.splice(injectedElements.indexOf(el), 1);
            el = null;
            callback(new Error('Parent node is null'));
            return;
        }
        el.parentNode.replaceChild(svg, el);
        injectedElements.splice(injectedElements.indexOf(el), 1);
        el = null;
        callback(null, svg);
    };
    if (dataUrlResult) {
        setTimeout(function () {
            handleLoadedSvg(null, dataUrlResult);
        }, 0);
        return;
    }
    var loadSvg = cacheRequests ? loadSvgCached : loadSvgUncached;
    loadSvg(baseUrl, httpRequestWithCredentials, handleLoadedSvg);
};
export default injectElement;
//# sourceMappingURL=inject-element.js.map